import { render, staticRenderFns } from "./LiveReporting.vue?vue&type=template&id=67561725&scoped=true&"
import script from "./LiveReporting.vue?vue&type=script&lang=js&"
export * from "./LiveReporting.vue?vue&type=script&lang=js&"
import style0 from "./LiveReporting.vue?vue&type=style&index=0&id=67561725&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67561725",
  null
  
)

export default component.exports